// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JNBf","colMin":"styles_colMin__C0JKW"};